
import {Component, OnInit} from '@angular/core';
import {EventsService} from '../../../events.service';
import {GlobalService} from '../../../../global.service';

@Component({
  selector: 'app-reno-cup-qualified',
  templateUrl: './reno-cup-qualified.component.html',
  styleUrls: ['./reno-cup-qualified.component.css']
})
export class RenoCupQualifiedComponent implements OnInit {
  participants;

  constructor(private eventService: EventsService, public globalService: GlobalService) {
  }

  ngOnInit() {
    this.eventService.getParticipants('QKGhaHz3Y5vV', 1).subscribe((res) => {
      this.participants = res.participants;
    });
  }

}
